/** @format */
import {ToggleOption} from 'components/buttons/CustomToggleButtonGroup/types';

import {DislikesAnswer, FormValues, HypothesisAnswer} from './types';

export const HYPOTHESIS_OPTIONS: ToggleOption<HypothesisAnswer>[] = [
  {
    value: 'no',
    label: 'Нет',
  },
  {
    value: 'no-maybe',
    label: 'Скорее нет',
  },
  {
    value: 'yes-maybe',
    label: 'Скорее да',
  },
  {
    value: 'yes',
    label: 'Да, взяли в работу',
  },
];

export const DISLIKES_OPTIONS: ToggleOption<DislikesAnswer>[] = [
  {
    value: 'bug',
    label: 'Ошибка или баг',
  },
  {
    value: 'no-metrics',
    label: 'Нет нужных метрик',
  },
  {
    value: 'few-specifics',
    label: 'Мало конкретики',
  },
];

export const MAX_CONTENT_WIDTH = 410;

export const MAX_COMMENT = 1000;

export const MAX_BUG_DESCRIPTION = 1000;

export const MAX_SCREENSHOTS = 8;

export const MAX_SCREENSHOT_SIZE_MB = 3;

export const DEFAULT_VALUES: FormValues = {
  rating: null,
  hypothesis: null,
  dislikes: [],
  bugDescription: '',
  screenshots: [],
  comment: '',
};

export const ID_ROOT = 'form-root';

export const ID_INPUT_RATING = 'input-rating';

export const ID_INPUT_HYPOTHESIS = 'input-hypothesis';

export const ID_INPUT_DISLIKES = 'input-dislikes';

export const ID_INPUT_BUG = 'input-bug';

export const ID_INPUT_COMMENT = 'input-comment';

export const ID_SUBMIT = 'form-submit';

export const ID_CANCEL = 'form-cancel';
